module.exports = __webpack_public_path__ + "img/icon3.46c57505.png";